export default {
      id: "organizations-usage",
      viewBox: "0 0 33.792 33.8",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#organizations",
      toString: function () {
        return this.url;
      }
    }